import { ProductField } from "@thenounproject/lingo-core";

import createEntityReducer from "../helpers/createEntityReducer";
import { getEntitiesFromAction, mergeEntitiesIfChanged } from "../helpers/mergeIfChanged";
export default createEntityReducer<ProductField>(
  "productFields",
  () => {},
  objectBuilder => {
    objectBuilder.addDefaultCase((state, action) => {
      const productFields = getEntitiesFromAction<ProductField>(action, "productFields");
      return mergeEntitiesIfChanged(state, productFields);
    });
  }
);
